/**
 * Initializes the configuration page
 */
 export default class ConfigurationPage {

    static init() {
        return new ConfigurationPage();
    }

    constructor() {
        const frameElement = document.getElementById('config-frame');
        if(!frameElement)
            return;
    
        frameElement.addEventListener('load', () => {
            this.configurationLoaded(frameElement);
        });
    }
    
    configurationLoaded(iframe) {
        const frame = window.frames[0];
        const body = frame.document.querySelector('body');
        if(!body)
            return;
    
        var iframeContentHeight = 0;
        body.classList.add('embedded');
        
        // constantly update iframe height to fit content
        setInterval(function(){
            if (body.scrollHeight != iframeContentHeight) {    
                iframeContentHeight = body.scrollHeight;
                iframe.style.height = iframeContentHeight + 'px';
            }
        }, 100);
        document.getElementById('loading-overlay').classList.add('hidden');
    }
}